import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { FaEnvelope, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

const EmailConfig = () => {
  const { fetchWithRetry } = useAuth();
  const [config, setConfig] = useState({
    smtpHost: "",
    smtpPort: "",
    smtpUser: "",
    smtpPass: "",
    fromEmail: "",
  });
  const [testEmail, setTestEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setConfig((await fetchWithRetry({ method: "get", url: "/api/admin/email-config" })).data);
      } catch (err) {
        setError("Không thể tải cấu hình email!");
      }
    };
    fetchConfig();
  }, [fetchWithRetry]);

  const handleChange = (e) => {
    setConfig({ ...config, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      await fetchWithRetry({
        method: "put",
        url: "/api/admin/email-config",
        data: config,
      });
      setSuccess("Cập nhật cấu hình email thành công!");
    } catch (err) {
      setError(err.response?.data?.message || "Lỗi khi cập nhật cấu hình email!");
    } finally {
      setLoading(false);
    }
  };

  const handleTestEmail = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      setSuccess(
        (await fetchWithRetry({
          method: "post",
          url: "/api/admin/email-config/test",
          data: { testEmail },
        })).data.message
      );
    } catch (err) {
      setError(err.response?.data?.message || "Lỗi khi gửi email kiểm tra!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4 flex items-center">
        <FaEnvelope className="mr-2" /> Cấu hình Server Mail
      </h2>

      {error && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 rounded flex items-center">
          <FaExclamationCircle className="mr-2" /> {error}
        </div>
      )}
      {success && (
        <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 rounded flex items-center">
          <FaCheckCircle className="mr-2" /> {success}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">SMTP Host</label>
          <input
            type="text"
            name="smtpHost"
            value={config.smtpHost}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            placeholder="smtp.gmail.com"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">SMTP Port</label>
          <input
            type="number"
            name="smtpPort"
            value={config.smtpPort}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            placeholder="587"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">SMTP User</label>
          <input
            type="email"
            name="smtpUser"
            value={config.smtpUser}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            placeholder="your-email@gmail.com"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">SMTP Password</label>
          <input
            type="password"
            name="smtpPass"
            value={config.smtpPass}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            placeholder="Your App Password"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">From Email</label>
          <input
            type="email"
            name="fromEmail"
            value={config.fromEmail}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            placeholder="noreply@yourdomain.com"
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-200 disabled:bg-gray-400"
        >
          {loading ? "Đang lưu..." : "Lưu cấu hình"}
        </button>
      </form>

      <div className="mt-6">
        <h3 className="text-lg font-semibold mb-2">Kiểm tra gửi email</h3>
        <div className="flex space-x-4">
          <input
            type="email"
            value={testEmail}
            onChange={(e) => setTestEmail(e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            placeholder="Nhập email để kiểm tra"
          />
          <button
            onClick={handleTestEmail}
            disabled={loading || !testEmail}
            className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition duration-200 disabled:bg-gray-400"
          >
            {loading ? "Đang gửi..." : "Gửi email kiểm tra"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailConfig;